var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoZakekeWhite = function SvgLogoZakekeWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "logoZakekeWhite_svg__Livello_1",
    x: 0,
    y: 0,
    viewBox: "0 0 190 31",
    className: "svgr-icon"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".logoZakekeWhite_svg__st0{fill:#fff}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.5 0v31h20.7v-6.5H117v-18h13.1V0z",
    className: "logoZakekeWhite_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M126.7 15.1c0 2.2-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8 3.8 1.7 3.8 3.8",
    style: {
      fill: "#98c225"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2 27.1c0 2.2-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8c2.1-.1 3.8 1.6 3.8 3.8",
    style: {
      fill: "#ef7f35"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m52.4 17.8 9.3 13.1h8.6L57.1 11.2zM78.9 31l3-4.5 1-1.4L100.2 0h-8.6l-8.7 11.9V0h-7.6v31zM104.5 31 93.6 14.1 88.9 21l6.9 10zM169.2 0v31h20.7v-6.5h-13.1v-18h13.1V0z",
    className: "logoZakekeWhite_svg__st0"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M186.4 15.1c0 2.2-1.7 3.8-3.8 3.8s-3.8-1.7-3.8-3.8 1.7-3.8 3.8-3.8 3.8 1.7 3.8 3.8",
    style: {
      fill: "#e6167f"
    }
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m138.6 31 3-4.5 1-1.4L159.9 0h-8.6l-8.7 11.9V0H135v31zM164.2 31l-10.9-16.9-4.7 6.9 6.9 10zM26.3 0H.1v6.5h16.3L0 26.5V31h26.3v-6.5H10.5L26.3 5zM40.1 30.9 61.5 0h-8.6L31.2 30.9z",
    className: "logoZakekeWhite_svg__st0"
  })));
};
export default SvgLogoZakekeWhite;